import React, { FC, useContext, useEffect, useState } from "react";
import { KTSVG, toAbsoluteUrl } from "../../../../../_metronic/helpers";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../auth";
import { AlertContext } from "../../../../../_metronic/layout/components/alert-context";
import { Employers } from "../employers-list/core/_models";
import { getRole } from "../../role-access/role-setting-list/core/_requests";
import { viewEmployers } from "../employers-list/core/_requests";
import Avatar from "react-avatar";

const EmployersView: React.FC = () => {
  const { showAlert } = useContext(AlertContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
//   const [role, setRole] = useState<any>([]);
  const [profile, setProfile] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [formImage, setFormImage] = useState<File | null>(null);

  const imageUrl = process.env.REACT_APP_IMAGE_UPLOADS;

  //Image Target
  interface Event<T = EventTarget> {
    target: T;
    // ...
  }

//   useEffect(() => {
//     getRole().then((res: any) => {
//       setRole(res?.data);
//     });
//   }, []);

  useEffect(() => {
    viewEmployers(id).then((res: any) => {
        console.log('EmpreHeaderView====', res)
      setProfile(res.Data);
    });
  }, []);

  var downloadResume = profile?.resume;

  // console.log("profile==========", profile);
  return (
    <>
      <div className="card mb-5 mb-xl-10">
        <div className="card-body pt-9 pb-0">
          <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
            <div className="me-7 mb-4">
              <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                {profile?.profile ? (
                  <div className="symbol symbol-100px symbol-lg-140px symbol-fixed position-relative">
                    <img
                      src={profile?.profile}
                      alt="ProfileImage"
                      style={{ objectFit: "contain" }}
                      className="w-100"
                    />
                  </div>
                ) : (
                  <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                    <Avatar
                      name={profile?.firstName}
                      maxInitials={2}
                      round
                      color="#607458"
                      fgColor="#1b1b29"
                    ></Avatar>
                  </div>
                )}
              </div>
            </div>
            <div className="flex-grow-1">
              <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                <div className="col-xl-9 col-lg-9 col-md-9">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center mb-2 mx-4">
                      <a className="text-gray-800 fs-2 fw-bolder me-1">
                        {profile?.firstName}
                        {profile?.aboutUser ? ` (${profile.aboutUser})` : ""}
                      </a>
                    </div>

                    <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                      {profile?.categoryId === 1 ? (
                        <a className="btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3">
                          Fresher
                        </a>
                      ) : profile?.categoryId === 2 ? (
                        <a className="btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3">
                          Experience
                        </a>
                      ) : (
                        ""
                      )}
                      {/* <a className='btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3'>
                      {profile?.categoryId === 1
                        ? 'Fresher'
                        : profile?.categoryId === 2
                        ? 'experience'
                        : ''}
                    </a> */}
                    </div>
                  </div>
                </div>
                {/* {roleaccess?.edit === 1 ? (
                  <Link to={editProfile} className='btn btn-primary align-self-center'>
                    Edit Profile
                  </Link>
                ) : (
                  ''
                )} */}
                {/* <div className="d-flex align-items-center position-relative my-1">
                  <Link
                    to={downloadResume}
                    className="btn btn-primary align-self-center"
                  >
                    Download Resume
                  </Link>
                </div> */}
              </div>
              <div className="d-flex flex-wrap flex-stack">
                <div className="d-flex flex-column flex-grow-1 pe-8">
                  <div className="d-flex flex-wrap">
                    <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                      <div className="d-flex align-items-center">
                        {/* <KTIcon iconName="multimedia" className="fs-3" /> */}
                        <i className="fas fa-phone text-success mr-5 me-2"></i>
                        <div className="fs-7 fw-bolder">{profile?.mobile}</div>
                      </div>
                    </div>
                    <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                      <div className="d-flex align-items-center">
                        {/* <KTIcon iconName=" " className="fs-3" /> */}
                        <i className="fas fa-envelope text-success mr-5 me-2"></i>
                        <div className="fs-7 fw-bolder">{profile?.emailId}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </>
  );
};

export default EmployersView;
